// extracted by mini-css-extract-plugin
module.exports = {"table":"TopFlopTable_table__2oIqv"};